import { inject, provide, type InjectionKey } from 'vue';
import { Container } from '@/shared/di';
import { SERP_PRODUCT_SEARCH_TOKEN, SERP_SEARCH_CRITERIA_TOKEN } from './tokens';
import type { SerpDependencies } from './types';

export const SERP_CONTAINER: InjectionKey<Container> = Symbol('serp-container');

/** Вызывается на конкретной странице SERP до рендера лэйаута. */
export function provideSerp(dependencies: SerpDependencies): SerpDependencies {
  const container = new Container();

  container.register(SERP_SEARCH_CRITERIA_TOKEN, dependencies.useSearchCriteria);
  container.register(SERP_PRODUCT_SEARCH_TOKEN, dependencies.productSearch);

  provide(SERP_CONTAINER, container);

  return dependencies;
}

/** Доступ к зависимостям SERP из лэйаута и его потомков. */
export function useSerp(): SerpDependencies {
  const container = inject(SERP_CONTAINER, null);

  if (!container) {
    throw new Error(
      '[travelata-frontend] useSerp: DI-контейнер SERP не предоставлен. Вызови provideSerp() на странице до рендера лэйаута.',
    );
  }

  return {
    useSearchCriteria: container.resolve(SERP_SEARCH_CRITERIA_TOKEN),
    productSearch: container.resolve(SERP_PRODUCT_SEARCH_TOKEN),
  };
}
